import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { compose } from "redux";

import { actions as topikActions } from "../../../../modules/topik";
import { draftKey } from "../useDraft";
import SingleTextAnalysisStep from "./SingleTextAnalysisStep";

// Continue-branch step (§6.2a b): dynamic prompt splices the player's own prior idea text,
// in full - capped at MAX_TEXT_LENGTH server-side, and the player needs to see exactly what
// they wrote to build on it.
const TopikSolutionMaximizerView = ({ t, session, topikStatus, gameClosed, dispatch }) => (
  <SingleTextAnalysisStep
    t={t}
    title={t("topik-solution-maximizer-view.title")}
    instruction={t("topik-solution-maximizer-view.instruction", { solution: session.solution })}
    placeholder={t("topik-solution-maximizer-view.placeholder")}
    submitLabel={t("topik-solution-maximizer-view.submit")}
    initialValue={session.solutionMaximizer || ""}
    draftKey={draftKey(session, "solution_maximizer")}
    maxLength={session.maxTextLength}
    submitting={topikStatus.submitting}
    gameClosed={gameClosed}
    error={topikStatus.error}
    assistStep="solutionMaximizer"
    onBack={() => dispatch(topikActions.analysis.back.request())}
    onSubmit={(solutionMaximizer) => (
      dispatch(topikActions.analysis.solutionMaximizer.request({ solutionMaximizer }))
    )}
  />
);

TopikSolutionMaximizerView.propTypes = {
  t: PropTypes.func.isRequired,
  session: PropTypes.object.isRequired,
  topikStatus: PropTypes.object.isRequired,
  gameClosed: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
};

TopikSolutionMaximizerView.defaultProps = {
  gameClosed: false,
};

const mapStateToProps = (state) => ({
  session: state.topik.session,
  topikStatus: state.topik.status,
});

export default compose(
  withTranslation("views"), connect(mapStateToProps),
)(TopikSolutionMaximizerView);
